import {
  GET_PORTFOLIO_NFTS_REQUEST,
  GET_PORTFOLIO_NFTS_SUCCESS,
  GET_PORTFOLIO_NFTS_FAILURE,
  GET_PORTFOLIO_NFTS_CHAMPIONS_FAILURE,
  GET_PORTFOLIO_NFTS_CHAMPIONS_REQUEST,
  GET_PORTFOLIO_NFTS_CHAMPIONS_SUCCESS,
  GET_PORTFOLIO_NFT_OWNED_FAILURE,
  GET_PORTFOLIO_NFT_OWNED_REQUEST,
  GET_PORTFOLIO_NFT_OWNED_SUCCESS,
  GET_PORTFOLIO_NFT_STAKING_FAILURE,
  GET_PORTFOLIO_NFT_STAKING_REQUEST,
  GET_PORTFOLIO_NFT_STAKING_SUCCESS,
  GET_PORTFOLIO_NFT_REQUEST,
  GET_PORTFOLIO_NFT_SUCCESS,
  GET_PORTFOLIO_NFT_FAILURE,
  GET_PORTFOLIO_NFT_STAKES_REQUEST,
  GET_PORTFOLIO_NFT_STAKES_SUCCESS,
  GET_PORTFOLIO_NFT_STAKES_FAILURE,
  MINT_NFT_TICKET_REQUEST,
  MINT_NFT_TICKET_SUCCESS,
  MINT_NFT_TICKET_FAILURE,
  CLEAR_MINT_NFT_TICKET_STATE,
} from 'redux/actionTypes/portfolioActionTypes';

const INITIAL_STATE = {
  gettingPortfolioNfts: false,
  gettingPortfolioNftsError: '',
  portfolioNfts: [],

  gettingPortfolioNftsChampions: false,
  gettingPortfolioNftsChampionsError: '',
  portfolioNftsChampions: {},

  portfolioNftOwnedState: {},

  portfolioNftStakingState: {},

  gettingPortfolioNft: false,
  gettingPortfolioNftError: '',
  portfolioNft: null,

  gettingPortfolioNftStakes: false,
  gettingPortfolioNftStakesError: '',
  portfolioNftStakes: [],

  mintingState: {},
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_PORTFOLIO_NFTS_REQUEST:
      return {
        ...state,
        gettingPortfolioNfts: true,
        gettingPortfolioNftsError: '',
      };

    case GET_PORTFOLIO_NFTS_SUCCESS:
      return {
        ...state,
        gettingPortfolioNfts: false,
        gettingPortfolioNftsError: '',
        portfolioNfts: payload,
      };

    case GET_PORTFOLIO_NFTS_FAILURE:
      return {
        ...state,
        gettingPortfolioNfts: false,
        gettingPortfolioNftsError: payload,
      };

    case GET_PORTFOLIO_NFTS_CHAMPIONS_REQUEST:
      return {
        ...state,
        gettingPortfolioNftsChampions: true,
        gettingPortfolioNftsChampionsError: '',
      };

    case GET_PORTFOLIO_NFTS_CHAMPIONS_SUCCESS:
      return {
        ...state,
        gettingPortfolioNftsChampions: false,
        gettingPortfolioNftsChampionsError: '',
        portfolioNftsChampions: payload,
      };

    case GET_PORTFOLIO_NFTS_CHAMPIONS_FAILURE:
      return {
        ...state,
        gettingPortfolioNftsChampions: false,
        gettingPortfolioNftsChampionsError: payload,
      };

    case GET_PORTFOLIO_NFT_OWNED_REQUEST:
      return {
        ...state,
        portfolioNftOwnedState: {
          ...state.portfolioNftOwnedState,
          [action.nftId]: {
            ...state.portfolioNftOwnedState[action.nftId],
            gettingPortfolioNftOwned: true,
            gettingPortfolioNftOwnedError: '',
          },
        },
      };

    case GET_PORTFOLIO_NFT_OWNED_SUCCESS:
      return {
        ...state,
        portfolioNftOwnedState: {
          ...state.portfolioNftOwnedState,
          [action.nftId]: {
            ...state.portfolioNftOwnedState[action.nftId],
            gettingPortfolioNftOwned: false,
            gettingPortfolioNftOwnedError: '',
            portfolioNftOwned: payload,
          },
        },
      };

    case GET_PORTFOLIO_NFT_OWNED_FAILURE:
      return {
        ...state,
        portfolioNftOwnedState: {
          ...state.portfolioNftOwnedState,
          [action.nftId]: {
            ...state.portfolioNftOwnedState[action.nftId],
            gettingPortfolioNftOwned: false,
            gettingPortfolioNftOwnedError: payload,
          },
        },
      };

    case GET_PORTFOLIO_NFT_STAKING_REQUEST:
      return {
        ...state,
        portfolioNftStakingState: {
          ...state.portfolioNftStakingState,
          [action.nftId]: {
            ...state.portfolioNftStakingState[action.nftId],
            gettingPortfolioNftStaking: true,
            gettingPortfolioNftStakingError: '',
          },
        },
      };

    case GET_PORTFOLIO_NFT_STAKING_SUCCESS:
      return {
        ...state,
        portfolioNftStakingState: {
          ...state.portfolioNftStakingState,
          [action.nftId]: {
            ...state.portfolioNftStakingState[action.nftId],
            gettingPortfolioNftStaking: false,
            gettingPortfolioNftStakingError: '',
            portfolioNftStaking: payload,
          },
        },
      };

    case GET_PORTFOLIO_NFT_STAKING_FAILURE:
      return {
        ...state,
        portfolioNftStakingState: {
          ...state.portfolioNftStakingState,
          [action.nftId]: {
            ...state.portfolioNftStakingState[action.nftId],
            gettingPortfolioNftStaking: false,
            gettingPortfolioNftStakingError: payload,
          },
        },
      };

    case GET_PORTFOLIO_NFT_REQUEST:
      return {
        ...state,
        gettingPortfolioNft: true,
        gettingPortfolioNftError: '',
      };

    case GET_PORTFOLIO_NFT_SUCCESS:
      return {
        ...state,
        gettingPortfolioNft: false,
        gettingPortfolioNftError: '',
        portfolioNft: payload,
      };

    case GET_PORTFOLIO_NFT_FAILURE:
      return {
        ...state,
        gettingPortfolioNft: false,
        gettingPortfolioNftError: payload,
      };

    case GET_PORTFOLIO_NFT_STAKES_REQUEST:
      return {
        ...state,
        gettingPortfolioNftStakes: true,
        gettingPortfolioNftStakesError: '',
      };

    case GET_PORTFOLIO_NFT_STAKES_SUCCESS:
      return {
        ...state,
        gettingPortfolioNftStakes: false,
        gettingPortfolioNftStakesError: '',
        portfolioNftStakes: payload,
      };

    case GET_PORTFOLIO_NFT_STAKES_FAILURE:
      return {
        ...state,
        gettingPortfolioNftStakes: false,
        gettingPortfolioNftStakesError: payload,
      };

    case MINT_NFT_TICKET_REQUEST:
      return {
        ...state,
        mintingState: {
          ...state.mintingState,
          [action.nftId]: {
            ...state.mintingState[action.nftId],
            minting: true,
            mintingError: '',
          },
        },
      };

    case MINT_NFT_TICKET_SUCCESS: {
      const stakes = [...state.portfolioNftStakes].map((_stake) => {
        const stake = { ..._stake };

        if (!stake.claimed && !stake.claimIn) {
          stake.claimed = stake.toClaim;
          stake.toClaim = undefined;
          stake.claimIn = '';
          stake.staking = '';
          stake.isWithdrawn = true;
        }

        return { ...stake };
      });

      return {
        ...state,
        portfolioNftStakes: stakes,
        mintingState: {
          ...state.mintingState,
          [action.nftId]: {
            ...state.mintingState[action.nftId],
            minting: false,
            mintingError: '',
          },
        },
      };
    }

    case MINT_NFT_TICKET_FAILURE:
      return {
        ...state,
        mintingState: {
          ...state.mintingState,
          [action.nftId]: {
            ...state.mintingState[action.nftId],
            minting: false,
            mintingError: payload,
          },
        },
      };

    case CLEAR_MINT_NFT_TICKET_STATE:
      return {
        ...state,
        mintingState: {
          ...state.mintingState,
          [action.nftId]: {
            ...state.mintingState[action.nftId],
            mintingError: '',
          },
        },
      };

    default:
      return state;
  }
};
